/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define([], function() {
    'use strict';
    function convertRelativePathToAbsolute(styleUrl) {
        return window.location.protocol + '//' + window.location.host + styleUrl;
    }

    function toAbsoluteUrl(url) {

        if (url.indexOf('://') === -1) {
            url = convertRelativePathToAbsolute(url);
        }

        return url;
    }
    return {
        convert: toAbsoluteUrl
    };
});



// WEBPACK FOOTER //
// ./display/layers/vector/setStyleMethodModifier/relativeToAbsolutePathConverter.js